import SR_TypeComponent from '../../Components/Masters/SR_Type/SR_TypeComponent'

function SR_TypePage() {
    return (
        <SR_TypeComponent/>
    )
}

export default SR_TypePage